import styled from '@emotion/styled';

export const RulesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;
export const RulesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6rem;
	padding: 8rem 0rem;
`;
export const RulesCategoryList = styled.div`
	display: flex; /* 가로 스크롤이 잘 적용되도록 변경 */
	width: 100%;
	height: 5.2rem;
	overflow-x: auto; /* 가로 스크롤 활성화 */
	white-space: nowrap; /* 줄 바꿈 방지 */
	scrollbar-width: none; /* Firefox에서 스크롤바 숨기기 */
	scrollbar-color: #ccc transparent; /* Firefox 스크롤 색상 */
	@media screen and (max-width: 1370px) {
		padding: 0 2rem;
	}
	&::-webkit-scrollbar {
		display: none;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #ccc; /* 스크롤바 색상 */
		border-radius: 3px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}
`;
export const RulesHistory = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-left: auto;
	margin-bottom: -4rem;
`;
export const RulesCategory = styled.div`
	flex: 0 0 auto;
	min-width: 12rem;
	max-width: calc(100% / 2);
	width: 100%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	background-color: #f1f3f5;
	border-left: 1px solid #dee2e6;
	cursor: pointer;
	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}
	&:first-of-type {
		border-left: none;
	}
`;
export const RulesTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const RulesSubTitle = styled.h3`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const RulesDescription = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const RulesContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const RulesContentItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const RulesContentItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;
export const DescriptionBox = styled.ol`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem;
	background-color: #f8f9fa;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #495057;
	list-style: none; /* 기본 스타일 초기화 */
	counter-reset: list-counter; /* 초기화 */
	> li {
		counter-increment: list-counter; /* 기본 번호 */
		position: relative;
		padding-left: 1.8rem; /* 번호를 위한 공간 확보 */
	}
	> li::before {
		content: counter(list-counter) '. ';
		position: absolute;
		left: 0;
		color: #495057;
	}
	ol[type='a'] {
		list-style-type: none; /* 기본 숫자 스타일 초기화 */
		padding-left: 1.5rem;
		counter-reset: list-counter; /* 알파벳 번호 초기화 */
	}
	ol[type='a'] > li {
		counter-increment: list-counter; /* 각 li마다 카운트 증가 */
	}
	ol[type='a'] > li::before {
		content: counter(list-counter, lower-alpha) '. '; /* 소문자 알파벳 번호 */
	}
`;
export const RulesSubmissionContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
export const RulesSubmissionDescriptionBox = styled.ol`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #495057;
	list-style: none; /* 기본 스타일 초기화 */
	counter-reset: list-counter; //* 초기화 */
	> li {
		counter-increment: list-counter; /* 기본 번호 */
		position: relative;
		padding-left: 2.8rem; /* 번호를 위한 공간 확보 */
		color: var(--Colors-Font---color-font-darker, #212529);
	}
	> li::before {
		content: counter(list-counter) '. ';
		position: absolute;
		left: 0;
		color: #495057;
	}
	ol[type='a'] {
		list-style-type: none; /* 기본 숫자 스타일 초기화 */
		padding-left: 1.5rem;
		counter-reset: list-counter; /* 알파벳 번호 초기화 */
	}
	ol[type='a'] > li {
		counter-increment: list-counter; /* 각 li마다 카운트 증가 */
	}
	ol[type='a'] > li::before {
		content: counter(list-counter, lower-alpha) '. '; /* 소문자 알파벳 번호 */
	}
`;
export const RulesTableSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	max-width: 72rem;
	width: 100%;
	margin: 0 auto;
`;
export const RulesTableScroll = styled.div`
	width: 100%;
	overflow-x: auto;
`;
export const RulesTable = styled.table`
	width: 100%;
	min-width: 68rem;
	border-collapse: collapse;
	border: 2px solid #212529;
	background: #fff;

	th,
	td {
		border: 1px solid #868e96;
		padding: 1.4rem 1.2rem;
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		line-height: 1.5;
		letter-spacing: -0.04em;
		color: #212529;
		text-align: center;
		vertical-align: middle;
		word-break: keep-all;
	}

	thead th {
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		border-bottom: 3px solid #212529;
		background: #f8f9fa;
	}

	tbody td {
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	}

	.total-row td {
		background: #e9ecef;
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	}
`;
